class WageLossCalc {
    constructor() {
        this.setupDefaults();
    }

    setupDefaults() {
    }

    onReadyEvents() {
        if ($("#wageLossCalc").length > 0) {
            var increment = $("#wageLossCalc #wageLoss-Base").val();
            if ($("#wageLossCalc #wageLoss-Increment").val() != "") {
                increment = $("#wageLossCalc #wageLoss-Increment").val();
            }
            var wageLoss = parseFloat(increment);
            var wageLossSince = parseFloat($('#wageLossCalc .calculatedResult').html().replace('$', '').replace(/,/g, ''));
            var interval = $("#wageLossCalc #wageLoss-Interval").val();

            setInterval(function () {
                wageLossSince += wageLoss;
                $('#wageLossCalc .calculatedResult').text('$' + wageLossSince.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
            }, interval);
            console.log("wage loss fired off");
        }
    }
}

export default WageLossCalc;